/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/**
 * Undocumented experimental feature: inline editing.
 *
 * TODO: Offer a a way to customize the value displayed, plain value may be unreadable.
 */


import {Component} from '@angular/core';
import {StackControl} from './stack-control';
import {StackView} from './stack-view';
export class StackSelect extends StackControl {
/**
 * @param {?} stackView
 */
constructor(public stackView: StackView) {
        super(stackView);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-stack-select",
    inputs: ["model: clrModel"],
    outputs: ["modelChange: clrModelChange"],
    template: `
        <span *ngIf="!stackView.editing">{{model}}</span>
        <div class="select" *ngIf="stackView.editing" >
            <select [(ngModel)]="model">
                <ng-content></ng-content>
            </select>
        </div>
    `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: StackView, },
];
}

function StackSelect_tsickle_Closure_declarations() {
/** @type {?} */
StackSelect.decorators;
/**
 * @nocollapse
 * @type {?}
 */
StackSelect.ctorParameters;
/** @type {?} */
StackSelect.prototype.stackView;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
